/* @flow */

//----------------------------------------------------------------------//
// LOCAL IMPORTS
//----------------------------------------------------------------------//

import Form from 'forms/_.extend';

//----------------------------------------------------------------------//
// FORM SETUP
//----------------------------------------------------------------------//

export const setupManufacturerAddition: Function = (
  action: Object,
  notification: Object,
  handleSubmit: Function,
  onSuccess: Function,
  t: Function
) => {
  const fields: Array<Object> = [
    {
      name: 'manufacturerAddition',
      label: t('general:manufacturer'),
      fields: [
        {
          name: 'name',
          label: t('general:manufacturer'),
          placeholder: t('general:manufacturer'),
          rules: 'required|string',
          value: action.fields.name,
          extra: {
            selectID: action.fields ? action.fields.id : null,
            resetValue: (action && action.fields) || null,
            resetValueFields: [
              {
                field: 'name',
                value: 'name',
              },
              {
                field: 'code',
                value: 'code',
              },
              {
                field: 'short_code',
                value: 'short_code',
              },
              {
                field: 'key_oem',
                value: 'key_oem',
              },
            ],
            toggleToTextField: true,
            isTextField: true,
            textTitle: 'Choose existing',
            title: 'Use original',
            setSelectedFields: [
              {
                field: 'code',
                value: 'code',
              },
              {
                field: 'short_code',
                value: 'short_code',
              },
              {
                field: 'key_oem',
                value: 'key_oem',
                condition: {
                  if: true,
                  ifVal: true,
                  elseVal: false,
                },
              },
            ],
          },
        },
        {
          name: 'code',
          label: t('general:manufacturers.labels.code'),
          placeholder: 'Manufacturer code',
          rules: 'required|string',
          value: action.fields.code,
        },
        {
          name: 'short_code',
          label: t('general:manufacturers.labels.short_code'),
          placeholder: 'Manufacturer short code',
          rules: 'required|string',
          value: action.fields.short_code,
        },
        {
          name: 'key_oem',
          label: t('general:manufacturers.labels.key_oem'),
          rules: 'required|boolean',
          value: action.fields.key_oem,
          extra: {
            options: [
              {
                id: 'Yes',
                label: 'Yes',
                value: true,
              },
              {
                id: 'No',
                label: 'No',
                value: false,
              },
            ],
          },
        },
        {
          name: 'inEditMode',
          value: null,
        },
      ],
    },
  ];

  const hooks: Object = {
    onSuccess(data: Object) {
      let values: Object = data.values().manufacturerAddition;
      values = {
        ...values,
        event_parent_id: action.fields.event_parent_id,
        manufacturer_id: data.$('manufacturerAddition.name').extra.selectID,
        activity_tag: 'add_manufacturer',
        status: 'Approved',
      };

      const myAction = values.inEditMode
        ? notification.actions.find((act: Object) => act.type === 'merge')
        : notification.actions.find((act: Object) => act.type === 'approve');

      if (values.inEditMode) {
        myAction.endpoint = myAction.endpoint.replace(
          '{manufacturer_id}',
          data.$('manufacturerAddition.name').extra.selectID
        );
        values.manufacturer_id = myAction.fields.manufacturer_id;
      }

      delete values.inEditMode;
      handleSubmit(myAction, notification.template_values, values, onSuccess);
    },
  };

  return new Form(
    { fields },
    {
      hooks,
      name: 'manufacturerAdditionRequest',
    }
  );
};
